import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { UpdateLocationUser } from 'domain/usecases/update-location-user';
import { RemoteUpdateLocationUser } from 'data/usecases/update-location-user';

export const makeRemoteUpdateLocationUser = (): UpdateLocationUser => {
  return new RemoteUpdateLocationUser(makeApiUrl('/updateLocationUser'), makeAuthorizeHttpClientDecorator());
};
